const announcementBars = document.querySelectorAll(
  '[data-announcement-slider][data-slider-enabled="true"]:not(.swiper-initialized)'
);

if (announcementBars.length > 0) {
  announcementBars.forEach((slider) => {
    const slidesCount = slider.querySelectorAll('.swiper-slide').length;

    if (slidesCount <= 1) return;

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 6,
      loop: true,
      loopAdditionalSlides: slidesCount,
      loopedSlides: slidesCount,
      allowTouchMove: true,
      grabCursor: true,
      followFinger: true,
      simulateTouch: true,
      touchRatio: 1,
      longSwipes: true,
      longSwipesRatio: 0.1,
      longSwipesMs: 180,
      touchStartPreventDefault: false,
      preventClicks: false,
      preventClicksPropagation: false,
      threshold: 3,
      speed: Number(slider.dataset.sliderSpeed) || 350,
      autoplay: {
        delay: Number(slider.dataset.autoplayDelay) || 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        waitForTransition: true,
      },
    });
  });
}
